import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AuthServicesService } from '../../../services/auth-services.service';
import Auth from '@aws-amplify/auth';
import { Router } from '@angular/router';
import { from, of } from 'rxjs';
import { finalize, map, catchError } from 'rxjs/operators';
import { PortalService } from '../../../services/portal.service';

import { awsConfig } from '../../../../config_cognito';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  formUser: FormGroup;
  hideRequiredControl = new FormControl(false);
  hide = true;
  load = false;
  loadChangePass = false;
  token;
  warning = false;
  daysUntilReset;
  constructor(private build: FormBuilder,
    public auth: AuthServicesService,
    private router: Router,
    public portalService: PortalService,) {
    this.formUser = this.build.group({
      hideRequired: this.hideRequiredControl,
      username: [null, [Validators.required]],
      password: [null, [Validators.required]]
    }, this.validateUser);
  }

  ngOnInit(): void {
    localStorage.clear();
  }
  get emailInput() { return this.formUser.get('username'); }
  get passwordInput() { return this.formUser.get('password'); }

  validateUser(c: AbstractControl): { invalid: boolean } {
    c.get('password').setErrors({ noMatch: true });
    return { invalid: true };
  }


  getEmailInputError(message): void {
    if (this.emailInput.hasError('email')) {
      message = 'Usuario incorrecto';
    } else if (this.emailInput.hasError('required')) {
      message = 'Usuario es requerido';
    }
    return message;
  }

  getPasswordInputError(pass): void {
    if (this.passwordInput.hasError('required')) {
      pass = 'Contraseña es requerido';
    } else if (this.passwordInput.hasError('noMatch')) {
      pass = 'Usuario o contraseña incorecta';
    }
    return pass;
  }

  singnIn(): void {
    this.load = true;
    from(this.auth.signIn(this.emailInput.value, this.passwordInput.value))
      .pipe(
        map(user => {
          const daysSinceLast = user.challengeName != 'NEW_PASSWORD_REQUIRED' 
           ? Math.abs(new Date().getTime()-new Date(user.attributes['custom:fec_act_ctrsna']).getTime())/(1000*60*60*24)
           : 0
          let page = user.challengeName === 'NEW_PASSWORD_REQUIRED'
            ? ['/auth/first-pass']
            : daysSinceLast>=365 && user.username.includes("@")
            ? ['/auth/reset-pass']
            : ['/portal/'];
          if (daysSinceLast>=360 && daysSinceLast<365 && user.username.includes("@")) {
            this.warning = true;
            this.daysUntilReset = (365-daysSinceLast).toFixed(0)!='0' ? (365-daysSinceLast).toFixed(0) : '1';
            page = [];
          }
          if (user.challengeName !== 'NEW_PASSWORD_REQUIRED') {
            this.portalService.validateLogin('Login', '-').subscribe();
            const {
              idToken,
              refreshToken,
              accessToken
            } = user.signInUserSession;
            let cookies = document.cookie.split(";");  
            for (let i = 0; i < cookies.length; i++) {              
              var cookie = cookies[i];
              var eqPos = cookie.indexOf("=");
              var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }

            const now = new Date();
            let time = now.getTime();
            time += 3600 * 1000;
            now.setTime(time);

            const now2 = new Date();
            let time2 = now2.getTime();
            time2 += 21600 * 1000;
            now2.setTime(time2);

            if (document.domain == 'localhost') {
              document.cookie = `idToken=${idToken.jwtToken}; path=/; Expires=${now.toUTCString()};`;
              document.cookie = `accessToken=${accessToken.jwtToken}; path=/; Expires=${now.toUTCString()};`;
              document.cookie = `refreshToken=${refreshToken.token}; path=/; Expires=${now.toUTCString()};`;
              document.cookie = `email=${user.attributes.email}; path=/;`;
              document.cookie = `familyName=${user.attributes.family_name}; path=/;`;
              document.cookie = `name=${user.attributes.name}; path=/;`;
            } else {
              // PRD
              document.cookie = `idToken=${idToken.jwtToken}; path=/; domain=ransa.net; Expires=${now.toUTCString()};`;
              document.cookie = `accessToken=${accessToken.jwtToken}; path=/; domain=ransa.net; Expires=${now.toUTCString()};`;
              document.cookie = `refreshToken=${refreshToken.token}; path=/; domain=ransa.net; Expires=${now.toUTCString()};`;
              document.cookie = `email=${user.attributes.email}; path=/; domain=ransa.net;`;
              document.cookie = `familyName=${user.attributes.family_name}; path=/; domain=ransa.net;`;
              document.cookie = `name=${user.attributes.name}; path=/; domain=ransa.net`;
              // SBX-QAS
              // document.cookie = `idToken=${idToken.jwtToken}; path=/; domain=ransaaplicaciones.com; Expires=${now.toUTCString()};`;
              // document.cookie = `accessToken=${accessToken.jwtToken}; path=/; domain=ransaaplicaciones.com; Expires=${now.toUTCString()};`;
              // document.cookie = `refreshToken=${refreshToken.token}; path=/; domain=ransaaplicaciones.com; Expires=${now.toUTCString()};`;
              // document.cookie = `email=${user.attributes.email}; path=/; domain=ransaaplicaciones.com;`;
              // document.cookie = `familyName=${user.attributes.family_name}; path=/; domain=ransaaplicaciones.com;`;
              // document.cookie = `name=${user.attributes.name}; path=/; domain=ransaaplicaciones.com;`;
            }

          }
          return page;
        }
        ),
        catchError(err => {
          this.passwordInput.setErrors({ noMatch: true });
          return of({ msg: err });
        }),
        finalize(() => {
          this.load = false;
        })
      )
      .subscribe((msg: string[]) => {
          this.router.navigate(msg);
      });
  }

  changePass(): void {
    this.loadChangePass = true;
    this.router.navigate(['/auth/reset-pass']);
  }

  initiate(): void {
    this.load = true;
    this.router.navigate(['/portal/']);
  }
}